/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Account_BillingInputs */

const en_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account & Billing`)
};

const de_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto & Abrechnung`)
};

const fr_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte et facturation`)
};

const es_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta y facturación`)
};

const it_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account e fatturazione`)
};

const nl_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account en facturering`)
};

const pl_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto i płatności`)
};

const fi_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tili ja laskutus`)
};

const da_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto & fakturering`)
};

const sv_help_account_billing = /** @type {(inputs: Help_Account_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto och fakturering`)
};

/**
* | output |
* | --- |
* | "Account & Billing" |
*
* @param {Help_Account_BillingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_account_billing = /** @type {((inputs?: Help_Account_BillingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Account_BillingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_account_billing(inputs)
	if (locale === "fr") return fr_help_account_billing(inputs)
	if (locale === "es") return es_help_account_billing(inputs)
	if (locale === "it") return it_help_account_billing(inputs)
	if (locale === "nl") return nl_help_account_billing(inputs)
	if (locale === "pl") return pl_help_account_billing(inputs)
	if (locale === "fi") return fi_help_account_billing(inputs)
	if (locale === "da") return da_help_account_billing(inputs)
	if (locale === "sv") return sv_help_account_billing(inputs)
	return en_help_account_billing(inputs)
});